import { createReducer } from '@mews/framework';
import { META_STATE_SUCCEEDED } from '@mews-commander/legacy-entities/src/constants';
import { createEntityAsyncMetaHandlers } from '@mews-commander/legacy-entities/src/ducks/utils';
import {
    AVAILABILITY_ADJUSTMENT_UPDATE_STARTED,
    AVAILABILITY_ADJUSTMENT_UPDATE_SUCCEEDED,
    AVAILABILITY_ADJUSTMENT_UPDATE_FAILED,
    FORM_MODE_CHANGED,
    MONTH_CHANGED,
    WAS_RELEASE_OVERRIDEN,
} from '../actionTypes';
import { AdjustmentsState } from '../types';

const INITIAL_STATE: AdjustmentsState = {
    isEditMode: false,
    wasReleaseOverriden: false,
    month: 0,
    ...META_STATE_SUCCEEDED,
};

export default createReducer(INITIAL_STATE, {
    [FORM_MODE_CHANGED]: (state: AdjustmentsState, isEditMode: boolean): AdjustmentsState => ({
        ...state,
        wasReleaseOverriden: false,
        isEditMode,
    }),
    [MONTH_CHANGED]: (state: AdjustmentsState, month: number): AdjustmentsState => ({
        ...state,
        month,
    }),
    [WAS_RELEASE_OVERRIDEN]: (state: AdjustmentsState): AdjustmentsState => ({
        ...state,
        wasReleaseOverriden: true,
    }),
    ...createEntityAsyncMetaHandlers({
        STARTED: AVAILABILITY_ADJUSTMENT_UPDATE_STARTED,
        SUCCEEDED: AVAILABILITY_ADJUSTMENT_UPDATE_SUCCEEDED,
        FAILED: AVAILABILITY_ADJUSTMENT_UPDATE_FAILED,
    }),
});
